export const APP_VERSION="v0.2.0_rc167_cx | 23425bc7cdd0bff11dbfc398a44119b67c606559"
